const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;

const CastManagementMixin = require('./CastManagementMixin');

const CastManagement = createReactClass({
    displayName: 'CastManagement',
    mixins: [CastManagementMixin],

    getInitialState: function () {
        return {
            showSection: false
        }
    },

    /**
     * Tracks list table keys
     */
    tableKeys: {
        'Artist': 'artist',
        'Track Title': 'title',
        'Album': 'album',
        'Album Artist': 'album_artist',
        'Duration': 'duration'
    },

    /**
     * Table options for the tracks list
     *
     * @returns {object}
     */
    tracksListOptions: function () {
        const toMinutesString = this.toMinutesString;
        return {
            actionableRows: false,
            actionsCallback: this.handleAction,
            noPanel: true,
            hideSpinner: true,
            emptyText: 'No tracks selected yet :(',
            mutators: {
                duration: function (duration) {
                    return toMinutesString(duration);
                }
            }
        };
    },

    castLengthInfo: function (minutes, seconds) {
        if (isNaN(minutes) || isNaN(seconds)) {
            return <div>No track/recording.</div>
        }

        return <div>{minutes} Minutes {seconds} Seconds</div>
    },

    castInstructor: function (cast) {
        if (typeof this.props.instructor === 'string') {
            return <div>{this.props.instructor}</div>;
        }

        return <div>{cast.instructor ? cast.instructor.name : 'Instructor'}</div>;
    },

    castModality: function (cast) {
        if (typeof this.props.modality === 'string') {
            return <div>{this.props.modality}</div>;
        }

        return <div>{cast.modality ? cast.modality.label : 'Modality'}</div>;
    },

    castFormat: function (cast) {
        if (typeof this.props.format === 'string') {
            return <div>{this.props.format}</div>;
        }

        return <div>{cast.format ? cast.format.label : 'Format'}</div>;
    },

    _buildGenreBubbles: function () {
        if (typeof this.props.cast.genres === 'undefined') {
            return;
        }

        return this.props.cast.genres.map(function (genre, index) {
            return (
                <div key={index} className="selected-option">
                    <span>{genre.label}</span>
                </div>
            )
        });
    },

    _buildMovementsBoxes: function () {
        if (!this.props.cast.movements || typeof this.props.cast.movements === 'undefined' || this.props.cast.movements.length === 0) {
            return <p>No movements selected.</p>
        }

        return this.props.cast.movements.map(function (movement, index) {
            return (
                <div key={index} className="movement-image">
                    <img src={movement.image} height="50" width="50" alt="movement image"/>
                    <p>{movement.label}</p>
                </div>
            );
        });
    },

    render: function () {
        const cast = this.props.cast;
        const castLength = this.toMinutesString(cast.duration).split(':');
        return (
            <div className="cast-preview">
                <Row>
                    <Column grid="lg" size="12">
                        <h5>Content ID</h5>
                        <div>{cast.content_id}</div>
                    </Column>
                </Row>

                <Row>
                    <Column grid="lg" size="6">
                        <h5>Cast Title</h5>
                        <div>{cast.title}</div>
                    </Column>
                    <Column grid="lg" size="6">
                        <h5>Cast Length</h5>
                        {this.castLengthInfo(castLength[0], castLength[1])}
                    </Column>
                </Row>

                <Row>
                    <Column grid="lg" size="6">
                        <h5>Instructor</h5>
                        <div>{this.castInstructor(cast)}</div>
                    </Column>
                    <Column grid="lg" size="6">
                        <h5>Description</h5>
                        <div>{cast.description}</div>
                    </Column>
                </Row>

                <Row>
                    <Column grid="lg" size="6">
                        <h5>Modality</h5>
                        <div>{this.castModality(cast)}</div>
                    </Column>
                    <Column grid="lg" size="6">
                        <h5>Format</h5>
                        <div>{this.castFormat(cast)}</div>
                    </Column>
                </Row>

                <Row>
                    <Column grid="lg" size="6">
                        <h5>Movements</h5>
                        <div className="cast-preview-movements-container">{this._buildMovementsBoxes()}</div>
                    </Column>
                    <Column grid="lg" size="6">
                        <h5>Main Music Genres</h5>
                        <div className="cast-preview-genres-container">{this._buildGenreBubbles()}</div>
                    </Column>
                </Row>

                <Row>
                    <Column grid="lg" size="12">
                        <div className="progress cast-preview-progress-bar">
                            <div className="cast-preview-tracks-length">
                                {this.toMinutesString(this.selectedTracksLength(cast.tracks))}
                            </div>

                            <div className="cast-preview-target-duration">
                                {this.toMinutesString(cast.target_duration)}
                            </div>

                            <div className="progress-bar progress-bar-striped progress-bar-animated" style={this.progressBarWidth(cast)}/>
                        </div>
                    </Column>
                </Row>

                <Row>
                    <Column grid="lg" size="12">
                        <div className="cast-preview-table">
                            <Table data={this.props.cast.tracks}
                                   dataKeys={this.tableKeys}
                                   title={'Cast Library'} options={this.tracksListOptions()}/>
                        </div>
                    </Column>
                </Row>
            </div>
        )
    },
});

module.exports = CastManagement;
